import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=3ddebeb3&scoped=true&"
import script from "./settings.vue?vue&type=script&lang=js&"
export * from "./settings.vue?vue&type=script&lang=js&"
import style0 from "./settings.vue?vue&type=style&index=0&id=3ddebeb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddebeb3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/kroppensabc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ddebeb3')) {
      api.createRecord('3ddebeb3', component.options)
    } else {
      api.reload('3ddebeb3', component.options)
    }
    module.hot.accept("./settings.vue?vue&type=template&id=3ddebeb3&scoped=true&", function () {
      api.rerender('3ddebeb3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings.vue"
export default component.exports